import { IPagedListResponse } from "domain/types/global/pagedListResponse";
import { CampanhaResponse } from "./campanhaResponse";
import { CampanhaPedidoResgateResponse } from "./campanhaPedidoResgateResponse";
import ValidationResult from "domain/types/global/validationResult";

export const CAMPANHAS_USUARIO_ALL = 'CAMPANHAS_USUARIO_ALL'
export const CAMPANHAS_PEDIDORESGATE_LOTE = 'CAMPANHAS_PEDIDORESGATE_LOTE'

export interface CampanhasState {
	campanhasAll: CampanhaResponse[];
	CampanhasPedidoResgateLote: IPagedListResponse<CampanhaPedidoResgateResponse> | undefined,
	mudancaStatus: ValidationResult;
}

export interface CampanhasAllUsuarioAction {
	type: typeof CAMPANHAS_USUARIO_ALL,
	payload: CampanhaResponse[];
}

export interface CampanhasPedidoResgateLoteAction {
	type: typeof CAMPANHAS_PEDIDORESGATE_LOTE,
	payload: IPagedListResponse<CampanhaPedidoResgateResponse>
}

export type CampanhasActionTypes =
	CampanhasAllUsuarioAction |
	CampanhasPedidoResgateLoteAction